import React, { useState, useEffect, useRef } from 'react';

const TYPE_COLOR = { chat:'#0ABAB5', order:'#f59e0b', driver:'#3b82f6', payment:'#10b981', promo:'#a855f7', info:'#64748b' };

function TypeIcon({ type, color, size = 18 }) {
  const s = { width: size, height: size, display: 'block', flexShrink: 0 };
  if (type === 'chat') return (
    <svg style={{ width: size, height: size, flexShrink:0 }} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/></svg>
  );
  if (type === 'order') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 10V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V10"/>
      <path d="M23 3H1v7h22V3z"/><line x1="12" y1="3" x2="12" y2="21"/>
    </svg>
  );
  if (type === 'driver') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="3" width="15" height="13" rx="2"/>
      <path d="M16 8h4l3 5v3h-7V8z"/>
      <circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/>
    </svg>
  );
  if (type === 'payment') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/><line x1="6" y1="16" x2="10" y2="16"/>
    </svg>
  );
  if (type === 'promo') return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 12 20 22 4 22 4 12"/>
      <rect x="2" y="7" width="20" height="5" rx="1"/>
      <line x1="12" y1="22" x2="12" y2="7"/>
      <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
      <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
    </svg>
  );
  return (
    <svg style={s} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
    </svg>
  );
}

let _addToast = null;

export function fireNotificationToast(notif) {
  if (_addToast) _addToast(notif);
}

export default function NotificationToast({ isDark }) {
  const [toasts, setToasts]   = useState([]);
  const timers                = useRef({});

  useEffect(() => {
    _addToast = (notif) => {
      const id = `nt-${Date.now()}-${Math.random()}`;
      setToasts(prev => [{ ...notif, _id: id }, ...prev].slice(0, 4));
      timers.current[id] = setTimeout(() => dismiss(id), 5000);
    };
    return () => { _addToast = null; };
  }, []);

  const dismiss = (id) => {
    clearTimeout(timers.current[id]);
    delete timers.current[id];
    setToasts(prev => prev.filter(t => t._id !== id));
  };

  if (!toasts.length) return null;

  return (
    <div style={{
      position: 'fixed', top: 60, right: 12, zIndex: 99999,
      display: 'flex', flexDirection: 'column', gap: '0.5rem',
      pointerEvents: 'none',
    }}>
      {toasts.map(t => {
        const color = TYPE_COLOR[t.type] || '#0ABAB5';
        return (
          <div
            key={t._id}
            onClick={() => dismiss(t._id)}
            style={{
              pointerEvents: 'all',
              display: 'flex', gap: '0.6rem', alignItems: 'flex-start',
              padding: '0.7rem 0.9rem',
              borderRadius: '0.9rem',
              background: isDark ? 'rgba(13,27,42,0.97)' : 'rgba(255,255,255,0.97)',
              backdropFilter: 'blur(16px)',
              WebkitBackdropFilter: 'blur(16px)',
              border: `1px solid ${color}40`,
              boxShadow: `0 8px 32px rgba(0,0,0,0.25), 0 0 0 1px ${color}20`,
              minWidth: 260, maxWidth: 320,
              cursor: 'pointer',
              direction: 'rtl',
              fontFamily: "'Cairo', sans-serif",
              animation: 'nt-in 0.35s cubic-bezier(0.16,1,0.3,1) both',
            }}
          >
            <div style={{
              width: 44, height: 44, borderRadius: '0.75rem', flexShrink: 0,
              background: `${color}18`,
              border: `1.5px solid ${color}50`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              overflow: 'hidden',
            }}>
              <TypeIcon type={t.type} color={color} size={24} />
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <p style={{
                margin: 0, fontSize: '0.73rem', fontWeight: 800,
                color: isDark ? '#e2e8f0' : '#0f172a',
                lineHeight: 1.4,
              }}>{t.title}</p>
              {t.body && (
                <p style={{
                  margin: '0.15rem 0 0', fontSize: '0.65rem',
                  color: isDark ? 'rgba(255,255,255,0.5)' : 'rgba(15,23,42,0.5)',
                  lineHeight: 1.5,
                  overflow: 'hidden', display: '-webkit-box',
                  WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                }}>{t.body}</p>
              )}
            </div>
            {/* progress bar */}
            <div style={{
              position: 'absolute', bottom: 0, right: 0, left: 0,
              height: 3, borderRadius: '0 0 0.9rem 0.9rem',
              background: `${color}30`, overflow: 'hidden',
            }}>
              <div style={{
                height: '100%', background: color,
                animation: 'nt-bar 5s linear forwards',
              }}/>
            </div>
          </div>
        );
      })}
      <style>{`
        @keyframes nt-in {
          from { opacity:0; transform:translateX(24px) scale(0.95); }
          to   { opacity:1; transform:translateX(0)    scale(1); }
        }
        @keyframes nt-bar {
          from { width: 100%; }
          to   { width: 0%; }
        }
      `}</style>
    </div>
  );
}
